import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { FormField } from '@/components/form'
import { Label } from '@/components/label'

import { cn } from '@/utils/cn'

// eslint-disable-next-line react-refresh/only-export-components
export const targetStrategySchema = z.object({
    targetStrategy: z.enum(['CentralLimit', 'Midpoint', 'SweepAndRest'] as const),
})
type TargetStrategySchemaType = z.infer<typeof targetStrategySchema>

interface Props {
    form: UseFormReturn<TargetStrategySchemaType>
}

export default function CreateOrderTargetStrategyForm({ form }: Props) {
    const value = form.watch('targetStrategy')

    const className =
        'flex flex-col items-center justify-center gap-4 px-4 py-2 mb-1 text-center border-2 rounded-md cursor-pointer border-surface0 hover:border-primary'
    return (
        <div>
            <Label>Target Strategy</Label>
            <FormField
                control={form.control}
                name="targetStrategy"
                render={({ field }) => {
                    const onTargetStrategyChange = (target: TargetStrategySchemaType['targetStrategy']) => {
                        field.onChange(target)
                    }

                    return (
                        <div className="grid grid-cols-3 gap-4">
                            <div
                                className={cn(className, {
                                    'border-primary': value === 'CentralLimit',
                                })}
                                onClick={() => onTargetStrategyChange('CentralLimit')}
                            >
                                <p className="text-sm">Central Limit Order Book</p>
                            </div>
                            <div
                                className={cn(className, {
                                    'border-primary': value === 'Midpoint',
                                })}
                                onClick={() => onTargetStrategyChange('Midpoint')}
                            >
                                <p className="text-sm">Mid-Book</p>
                            </div>
                            <div
                                className={cn(className, {
                                    'border-primary': value === 'SweepAndRest',
                                })}
                                onClick={() => onTargetStrategyChange('SweepAndRest')}
                            >
                                <p className="text-sm">Sweep & Rest</p>
                            </div>
                        </div>
                    )
                }}
            />
        </div>
    )
}
